<template>
  <RevTooltip content-class-names="z-20 max-w-[250px]">
    <template #trigger="{ show, hide }">
      <RevTag
        :label="props.fixedMultiplier"
        variant="success"
        @focusin="show"
        @focusout="hide"
        @mouseleave="hide"
        @mouseover="show"
      />
    </template>

    {{ i18n(translations.rateInfoText) }}
  </RevTooltip>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag } from '@ds/components/Tag'
import { RevTooltip } from '@ds/components/Tooltip'

import translations from './RateExchangeTag.translations'

const i18n = useI18n()

const props = defineProps<{
  fixedMultiplier: string
}>()
</script>
